import React from "react";

const humanize = (s) => {
  if (!s) return "value";
  return String(s)
    .replace(/_/g, " ")
    .replace(/\b\w/g, (m) => m.toUpperCase());
};

export const InputField = ({ label, placeholder, className, ...props }) => {
  const generated =
    placeholder || (label ? `Enter ${label}` : `Enter ${humanize(props.name)}`);
  return <input placeholder={generated} className={className} {...props} />;
};

export const TextareaField = ({ label, placeholder, className, ...props }) => {
  const generated =
    placeholder || (label ? `Enter ${label}` : `Enter ${humanize(props.name)}`);
  return <textarea placeholder={generated} className={className} {...props} />;
};

export const SelectField = ({ children, className, ...props }) => {
  const base =
    className ||
    "bg-slate-100 px-4 py-3 rounded-lg border border-slate-200 focus:border-blue-500 focus:outline-none";
  return (
    <select className={base} {...props}>
      {children}
    </select>
  );
};

export const CheckboxField = ({ className, ...props }) => {
  const base = className || "mr-2 leading-tight";
  return <input className={base} type="checkbox" {...props} />;
};

export const ToggleField = ({ checked, onChange, name, className, label }) => {
  // Minimal toggle: a styled checkbox that matches form spacing
  return (
    <label className={`inline-flex items-center gap-2 ${className || ""}`}>
      <input
        type="checkbox"
        checked={checked}
        name={name}
        onChange={onChange}
        className="h-5 w-9 rounded-full appearance-none bg-slate-300 checked:bg-blue-600 relative before:absolute before:rounded-full before:bg-white before:h-4 before:w-4 before:left-0.5 before:top-0.5 checked:before:left-4 transition-all"
      />
      {label}
    </label>
  );
};

export default InputField;
